module.exports = __webpack_public_path__ + "img/product.13f706a0.png";